import copy from 'copy-to-clipboard';

import {Button, Modal, Text} from '#component/base';
import {ModalClose} from '#component/base/Modal';
import {EventType, useAnalytics, UserActionEvent} from '#component/provider/AnalyticsProvider';
import {SUPPORT_EMAIL} from '#constant/app';
import {useToastQueue} from '#hook';
import {sprinkles} from '#style/sprinkles';

export const ContactUsModal = () => {
  const {addToast} = useToastQueue();
  const {track} = useAnalytics();

  const handleCopyEmail = () => {
    track<UserActionEvent>({
      evtName: EventType.UserAction,
      actionName: 'Copied email',
    });

    copy(SUPPORT_EMAIL);
    addToast({children: 'Email address copied'});
  };

  return (
    <Modal
      footer={
        <Button as={ModalClose} onClick={handleCopyEmail}>
          Copy email address
        </Button>
      }>
      <div className={sprinkles({flex: 'flex', dir: 'col', gap: 16})}>
        <Text variant="heading2" color="burgundy">
          Contact Us
        </Text>

        <Text>
          {'Send us your questions/concerns to '}
          <Text as="a" fontWeight="semiBold" href={`mailto:${SUPPORT_EMAIL}`}>
            {SUPPORT_EMAIL}
          </Text>
          {
            ' with the email you use to access this account and weʼll be glad to help you from there.'
          }
        </Text>
      </div>
    </Modal>
  );
};
